import React, { useState } from 'react';
import { BlockUI } from 'primereact/blockui';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import useToken from '../../../hooks/useToken';
import { getCookieValue } from '../../Admin/Auth/Login/components/helper/helper';

const SessionExpiredPopup = ({ open, data }) => {
  const { logout } = useToken();
  const [isDisable, setIsDisable] = useState(false);

  const handleClose = async () => {
    setIsDisable(true);
    const isMpinSet = localStorage.getItem('is_mpin_enabled');
    const refreshToken = getCookieValue('refreshToken');

    if (isMpinSet === 'true' && refreshToken) {
      window.location.href = `${window.location.origin}/verify-pin`;
      return null;
    } else {
      const response = await logout(1);
      if (response) {
        setIsDisable(false);
      }
    }
  };
  const footerContent = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={handleClose}
        disabled={isDisable}
        autoFocus
        size="small"
        severity="info"
      />
    </div>
  );

  return (
    <BlockUI blocked={false}>
      <Dialog
        visible={open}
        header={data?.message?.title}
        footer={footerContent}
        onHide={() => {
          handleClose();
        }}
        modal
      >
        {data?.message?.message}
      </Dialog>
    </BlockUI>
  );
};

export default SessionExpiredPopup;
